import { Tooltip } from '@mui/material';
import React from 'react';
import Flex from 'ui/Flex/Flex';
import InfoIcon from '@mui/icons-material/Info';
type Props = {
    agentAttribute: string;
    tooltipText: string;
};
const AgentNameWithTooltipCellRenderer = (props: Props): React.ReactElement => {
    return (
        <Flex align="center">
            <Tooltip title={props.tooltipText}>
                <InfoIcon style={{ fontSize: 16, marginRight: 8 }} />
            </Tooltip>
            {props.agentAttribute}
        </Flex>
    );
};

export default AgentNameWithTooltipCellRenderer;
